import { type ClassValue, clsx } from 'clsx';

/** Joins class names; later utilities are written to win by order, not by merging. */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
